import { t } from "../../../i18n";
import { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import Title from "../../../layout/Title";
import { useDispatch } from "react-redux";
import { Spinner } from "../../../ui/Spinner";
import ModalCloseBtn from "../ui/ModalCloseBtn";
import ModalNavigation from "../ui/ModalNavigation";
import { getContainer } from "../../../ioc/IOCSetup";
import { ContentModelName } from "../../../contenful/types";
import { ResetPasswordChannel } from "../../../user/UserService";
import { LoginStatus, ResetPasswordStatus } from "../../../http/Types";
import { fetchAndParseContent } from "../../../contenful/ContentfulActions";
import { Status } from "../../../journey/UserJourneyReducer";
import RequestResetPasswordForm from "../../../user/ui/RequestResetPasswordForm";
import { ModalProps, PATH,} from "../UserModalController";
import { isHomeScreen, setModalPath, useClickOutside } from "../utils";
import { UserActionTypes } from "../../../user/UserActions";


const RecoverPasswordModal = (props: Partial<ModalProps>) => {

  const { history, user, content, journey } = props;
  const homeScreen = isHomeScreen();
  const dispatch = useDispatch();
  const ref = useRef(null);
  useClickOutside(ref, () => setModalPath({path: undefined, history}));

  // Defualt language is set in contentful
  const [ language ] = useState(()=> {
    try {
      return getContainer().getSettingsService().getActiveLocale().code;
    } catch (_) {
      return undefined
    }
  })

  useEffect(() => {
    dispatch({ type: UserActionTypes.RESET_PASSWORD_CLEAR });
  }, []);

  // Get Onboarding content
  useEffect(() => {
    if (content && content.onboardingpage === undefined) {
      dispatch(fetchAndParseContent(ContentModelName.ONBOARDINGPAGE, language) as any);
    }
    if (content && content.global === undefined) {
      dispatch(fetchAndParseContent(ContentModelName.GLOBAL) as any);
    }
  }, []);

  // Redirect to right modal based on auth proccess.
  const userStatus = user && user.status;

  useEffect(() => {
    if (history) {
      if (userStatus === LoginStatus.LOGGED_IN) {
        setModalPath({ path: undefined, history });
      }
    }
  }, [user]);

  const LoadingSpinner = <div id="sc" data-testid={PATH.RECOVER}><Spinner /></div>;

  if(journey && journey.status !== Status.DONE){
    return LoadingSpinner
  }

  const resetPasswordChannel = user && (user.resetPasswordChannel as ResetPasswordChannel);
  const resetPasswordStatus = user && (user.resetPasswordStatus as ResetPasswordStatus);
  const InProgress = resetPasswordStatus === ResetPasswordStatus.IN_PROGRESS;
  const resetWithEmail = resetPasswordChannel === "email";
  const resetWithSms = resetPasswordChannel === "sms";

  return (
    <div className={`modal-wrapper ${PATH.RECOVER} ${!homeScreen ? "active" : null}`} ref={!homeScreen ? ref : null}>
      {content && content.onboardingpage && content.global && (
        <div className="modal-container">
          {!homeScreen && <ModalCloseBtn onClick={()=>setModalPath({path: undefined, history})}/>}
          {InProgress ? <Alert emailReset={resetWithEmail} smsReset={resetWithSms} /> : (
            <>
              <Modal.Header>
                <Title animate={true} title={t("onboardingPage.recoverPasswordTitle")} />
              </Modal.Header>
              <Modal.Body>
                <RequestResetPasswordForm />
              </Modal.Body>
              <Modal.Footer>
                <ModalNavigation options={navigationOptions()} history={history} />
              </Modal.Footer>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default RecoverPasswordModal;



const Alert = ({ emailReset, smsReset }: { emailReset: boolean; smsReset: boolean }) => {
  return (
    <Modal.Body className="recover-alert">
      <div>
        <h2>{t("forms.resetPassword.onItsWay")}</h2>
        {emailReset && <h5>{t("forms.resetPassword.inProgressEmail")}</h5>}
        {smsReset && <h5>{t("forms.resetPassword.inProgressSms")}</h5>}
      </div>
    </Modal.Body>
  );
};

const navigationOptions = () => {
  return [
    {
      locales: "account.login",
      beforeAndAfterLocales: ["account.loginBefore", "account.loginAfter"],

      type: PATH.LOGIN,
    },
    {
      locales: "account.createAccount",
      beforeAndAfterLocales: ["account.createAccountBefore", "account.createAccountAfter"],
      type: PATH.REGISTRATION,
    },
  ];
};
